const keyByLang = ( key, currentLanguage ) => {
    return currentLanguage === "ru"
    ?   '' + key + '_ru'
    :   '' + key + '_ua'

    // usage - {order[this.getKeyByLang("title", currentLanguage)]}
    // current languages from global store
}

export default keyByLang;